import React, { Component } from 'react';
import { Query } from 'react-apollo';

import { queryDepartmentDetails } from '../../GraphQL/query/Department.query';
import Loading from '../../Components/Loading';

import DepartmentCardContainer from './MostDepartmentCard';

const MostDepartmentCard = ({ depId, hideHeart }) => (
  <Query
    query={queryDepartmentDetails}
    variables={{
      depId,
      showEvents: false,
      includeRound: true,
      showLikes: true,
      roundDetails: true,
    }}
  >
    {({ loading, error, data }) => {
      if (loading)
        return <Loading dimmer={false} loaderProps={{ active: true, inline: 'centered' }} />;
      if (error) return <div>{JSON.stringify(error)}</div>;
      if (data === null) return <div />;
      return <DepartmentCardContainer hideHeart={hideHeart} data={data.department} depId={depId} />;
    }}
  </Query>
);

export default MostDepartmentCard;
